import { RouteConfig } from 'vue-router';
const Home = () => import('./home.vue');
const Manage = () => import('../manage/manage.vue');
const Knowledge = () => import('../knowledge/knowledge.vue');
const Feedback = () => import('../feedback/feedback.vue');
import ManageRouterChildren from '../manage/manage.router';
import KnowledgeRouterChildren from '../knowledge/knowledge.router';
import FeedbackRouterChildren from '../feedback/feedback.router';
const routers: RouteConfig[] = [
    {
        path: 'home',
        component: Home,
    },
    {
        path: 'manage',
        component: Manage,
        children: ManageRouterChildren
    },
    {
        path: 'feedback',
        component: Feedback,
        children: FeedbackRouterChildren
    },
    {
        path: 'knowledge',
        component: Knowledge,
        children: KnowledgeRouterChildren
    },
];
export default routers;

